/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetDetailedStockArgs = {
  numero: string;
  marca: string;
  dispatcherTaxId: string;
};

type GetDetailedStockResponse = {
  state: number;
  value: { mensaje: string; ok: boolean; okSpecified: boolean };
};

export const generateANPExport = async ({
  marca,
  numero,
  dispatcherTaxId,
}: GetDetailedStockArgs): Promise<GetDetailedStockResponse> => {
  try {
    const res = await apiClient.post<any>(Endpoints.ANPExport, {
      marca,
      numero,
      rut: dispatcherTaxId,
    });
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
